import styled, { css } from 'styled-components';

interface AvatarProps {
  size: number;
  bordered: boolean;
  tone?: string;
}

export const Avatar = styled.span<AvatarProps>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  font-size: ${(props) => (props.size >= 32 ? 12 : 11)}px;
  font-weight: 600;
  border-radius: 50%;
  background: ${(props) => props.tone ?? props.theme.$gray500};
  color: ${(props) => props.theme.$gray900};

  ${(props) =>
    props.bordered &&
    css`
      border: 2px solid ${props.theme.$gray200};
    `}

  & + & {
    margin-left: ${(props) => (props.bordered ? -8 : -6)}px;
  }
`;
